import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Modal, Paragraph, Button } from '@vwfs-bronson/bronson-react'

export const MailDispatch = ({ 
  visible, 
  submitData, 
  displayData, 
  onClose, 
  onSendAgainSubmit
}) => {
  const { t } = useTranslation()
  const emailAddress = displayData.emailAddress
  const productName = displayData.productName

  return (
    <Modal
      testId="mailDispatchModal"
      id="mailDispatchModal"
      shown={visible}
      center
      title={t('sf-sac:mailDispatch:heading')}
      buttonCancelText={t('sf-sac:mailDispatch:buttonText')}
      className="c-modal--stretch"
      onClickOutside={onClose}
      onCancel={onClose}
      hideCloseButton
    >
      <i
        className={`c-icon c-icon--xxlarge c-icon--[${t(
          'sf-sac:mailDispatch:icon'
        )}]`}
        role="img"
        aria-hidden="true"
      ></i>
      <br />
      <br />
      <Paragraph>
        {t('sf-sac:mailDispatch:paragraph', { data: displayData, productName: productName, emailAddress: emailAddress })}
      </Paragraph>
      <Button
        link
        onClick={() => {
          onSendAgainSubmit(submitData)
        }}
      >
        {t('sf-sac:mailDispatch:sendLinkAgain')}
      </Button>
    </Modal>
  )
}
